<template>
  <div id="packaging_detail" class="h-full pb-2 overflow-y-auto" v-if="isLoaded">
    <div class="col-start-2 h-2/3 mb-3">
      <object class="w-4/5 mx-auto h-full" v-if="getAsset" width="100%" height="100%"
              :data="getAsset"
              type="application/pdf">
        <iframe :src="getAsset"></iframe>
      </object>
      <img v-else src="../../../assets/media/NoImage.png" alt="no image">
    </div>
    <div class="grid grid-cols-1 gap-5 xl:grid-cols-2">
      <div class="properties">
        <c-list-item :data="packagingData.type" :translation-key="'packagingType'"/>
        <c-list-item :data="packagingData.externalId" :translation-key="'packagingId'"/>
      </div>

      <div id="products" class="properties">
        <div id="linkedItem"
             class="grid grid-cols-2 text-left border-b-2 border-classen__secondary h-auto">
          <div>
            <label>{{ getTranslation('linkedProducts') }}</label>
          </div>
          <div class="overflow-y-auto">
            <template v-if="packagingData.type === 'box'"
                      v-for="product in packagingData.box_products">
              <label class="block underline cursor-pointer font-bold"
                     @click="redirectToProduct(product)">
                {{ `${product.external_id} ${product.name}` }}</label>
            </template>
            <template v-if="packagingData.type === 'inlay'"
                      v-for="product in packagingData.inlay_products">
              <label class="block underline cursor-pointer font-bold"
                     @click="redirectToProduct(product)">
                {{ `${product.external_id} ${product.name}` }}
              </label>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import ListItem from "../ListItem";
import getTranslation from "../../../mixins/getTranslation";
import EventBus from "../../../services/EventBus";

export default {
  name: 'PackagingDetailForm',

  mixins: [getTranslation],

  props: {
    packaging: {required: true},
  },

  components: {
    'c-list-item': ListItem
  },

  data() {
    return {
      packagingData: null,
      isLoaded: false,
    }
  },

  created() {
    this.$dashboardStore.dispatch('getPackage', this.packaging.id)
      .then((res) => {
        this.packagingData = res.data
        this.isLoaded = true
      });
  },

  computed: {
    getAsset() {
      const foundAsset = this.packagingData.packageAssets.find((asset) => {
        return asset.type === 'uploads'
      })

      if (foundAsset) {
        return foundAsset.asset
      }

      return false
    }
  },

  methods: {
    redirectToProduct(product) {
      let prodCopy = product
      prodCopy.id = product.external_id
      EventBus.fire('set-active_product', prodCopy)
    }
  }
}
</script>
<style scoped>

img {
  width: 65%;
  max-height: 100%;
  object-fit: none;
}

#products {
  height: fit-content;
}

</style>
